import type { LevelConfig, LevelPiece } from "../level_config.js";

// Same numeric value as PlayDialogDifficulty.Common — kept as a literal
// instead of importing play_dialog.ts, same leaf-module reasoning as the
// other showcases' local COMMON_DIFFICULTY.
const COMMON_DIFFICULTY = 0;

/**
 * Static test level for the elevator table (see table_elevator.ts and
 * physics_table.ts #setElevation): two tables side by side, the left one
 * standing still and the right one riding its stack up and down, so the two
 * can be read against each other.
 *
 *   - only the post between the foot and the deck stretches. The foot never
 *     leaves the floor, which is the whole point of the separate `palka` mesh
 *     the leg model is built from;
 *   - the blocks are carried through the stroke explicitly every physics step
 *     (TableElevator), the way TableSwinger carries them through a swing;
 *   - the run sits entirely above the authored height, so the level looks at
 *     rest exactly as it was laid out and the camera frame is fitted to the
 *     top of the travel.
 */
const COLS = 4;
const ROWS = 3;

function makeDeck(): { grid: number[][]; pieces: LevelPiece[] }
{
  const grid: number[][] = [];
  const pieces: LevelPiece[] = [];
  let id = 1;

  for ( let row = 0; row < ROWS; row++ )
  {
    const grid_row: number[] = [];

    for ( let col = 0; col < COLS; col++ )
    {
      grid_row.push( id );
      pieces.push( { id, type: 1, x: col, y: row, width: 1, height: 1 } );
      id++;
    }

    grid.push( grid_row );
  }

  return { grid, pieces };
}

const ELEVATOR_TABLE_LEVEL: LevelConfig = {
  level: 90307,
  difficulty: COMMON_DIFFICULTY as LevelConfig["difficulty"],
  tables: [
    { layers: [ makeDeck() ], slot: { u: -1, v: 0 } },
    { layers: [ makeDeck() ], slot: { u: 1, v: 0 }, elevator: true },
  ],
};

export class ElevatorTableShowcase
{
  public static readonly LEVEL = ELEVATOR_TABLE_LEVEL.level;

  private static active = false;

  public static isActive(): boolean
  {
    return this.active;
  }

  public static activate(): number
  {
    this.active = true;
    return this.LEVEL;
  }

  public static deactivate(): void
  {
    this.active = false;
  }

  public static getConfig( level: number ): LevelConfig | null
  {
    return level === this.LEVEL ? ELEVATOR_TABLE_LEVEL : null;
  }
}
